import React from 'react';
import { Radio, StrictCheckboxProps } from 'semantic-ui-react';

export interface RadioInputProps extends Omit<StrictCheckboxProps, 'onChange'> {
  onChange?: (value: string) => void;
}

const RadioInput: React.FC<RadioInputProps> = ({ className, onChange, ...props }) => {
  const disabled = props.disabled || false;
  return (
    <Radio
      className={className}
      onChange={(_e, data): void => {
        onChange && onChange(data.value?.toString() ?? '');
      }}
      disabled={disabled}
      type='radio'
      {...props}
    />
  );
};

export default RadioInput;
